export const parseArrayBuffer = (arrayBuffer: ArrayBuffer): unknown => {
  const textDecoder = new TextDecoder('utf-8');

  return JSON.parse(textDecoder.decode(new Uint8Array(arrayBuffer)));
};
